module.exports = __webpack_public_path__ + "static/images/imgBg03.87ec2b3.png";